import React, { useState } from "react";
import { Navbar } from "../../components/Navbar";
import { Sidebar } from "../../components/Sidebar";
import { useGetUserMe } from "../../features/user";

const Transaction: React.FC = () => {
  const [paymentCode, setPaymentCode] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const { userMe } = useGetUserMe();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPaymentCode(event.target.value);
  };

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    alert(`Kode pembayaran: ${paymentCode}`);
    // Di sini Anda bisa mengirim kode ke server atau memprosesnya sesuai kebutuhan.
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar toggleSidebar={toggleSidebar} />
      {/* iFrame untuk menampilkan website Telkomsel */}
      <iframe
        src="https://www.telkomsel.com/shops/channel/o2o?payment=outlet"
        title="Telkomsel Shop"
        className="flex-1 w-full border-2 border-gray-300"
      ></iframe>

      {/* Form untuk memasukkan kode pembayaran */}
      {/* <form
        onSubmit={handleFormSubmit}
        className="w-full p-4 bg-gray-100 flex flex-col items-center"
      >
        <label htmlFor="paymentCode" className="text-lg font-semibold mb-2">
          Paste Kode Pembayaran:
        </label>
        <input
          type="text"
          id="paymentCode"
          value={paymentCode}
          onChange={handleCodeChange}
          placeholder="Contoh: 123456"
          className="w-full max-w-lg px-4 py-2 border border-gray-300 rounded-lg mb-4"
        />
        <button
          type="submit"
          className="w-full max-w-lg px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          Submit
        </button>
      </form> */}
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        role={userMe?.role as "ADMIN" | "USER" | "CS"}
      />
    </div>
  );
};

export default Transaction;
